import { Route, Routes } from "react-router-dom";
//import A5Issuers from "./A5Issuers/main";
import A5DerivativeBarriers from "./A5DerivativeBarriers/main";
import A5DerivativeUnderlyings from "./A5DerivativeUnderlyings/main";
import A5DownloadCenter from "./A5DownloadCenter/main";
import A5Events from "./A5Events/main";
import A5Portfolios from "./A5Portfolios/main";
import A5PdfPageSelection from "./A5PdfPageSelection/main";
import A5StaticData from "./A5StaticData/main";
import A5TimeSeries from "./A5TimeSeries/main";
import A5Transactions from "./A5Transactions/main";
import A5DataUpload from "./A5DataUpload/main";
import A5BankPositions from "./A5BankPositions/main";

export default function A5Routes() {
  return (
    <Routes>
      {/*<Route path="a5_issuers/*" element={<A5Issuers />} />*/}
      <Route path="a5_events/*" element={<A5Events />} />
      <Route path="a5_portfolios/*" element={<A5Portfolios />} />
      <Route path="a5_static_data/*" element={<A5StaticData />} />
      <Route path="a5_time_series/*" element={<A5TimeSeries />} />
      <Route path="a5_transactions/*" element={<A5Transactions />} />
      <Route path="a5_bank_positions/*" element={<A5BankPositions />} />
      <Route path="a5_pdf_page_selection/*" element={<A5PdfPageSelection />} />
      <Route path="a5_download_center/*" element={<A5DownloadCenter />} />
      <Route path="a5_data_upload/*" element={<A5DataUpload />} />
      <Route
        path="a5_derivative_barriers/*"
        element={<A5DerivativeBarriers />}
      />
      <Route
        path="a5_derivative_underlyings/*"
        element={<A5DerivativeUnderlyings />}
      />
    </Routes>
  );
}
